module.exports = __webpack_public_path__ + "static/img/1-6.ffb03a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/1-6.jpg
// module id = IU3X
// module chunks = 25